import React from 'react';
import {map} from 'lodash';
import {camelizeKeys} from 'humps';
import CriterionFactory from 'src/components/scholarship-programs/criterion-factory';

interface Props {
  criteria: $TSFixMe;
  onHighSchoolListClick: () => void;
}

const Criteria = ({criteria, onHighSchoolListClick}: Props) => {
  if (criteria.length < 1) {
    return null;
  }

  return (
    <div className="eligibility-criteria">
      {map(criteria, (criterion) => (
        <CriterionFactory
          key={criterion._id}
          criterion={camelizeKeys(criterion)}
          onHighSchoolListClick={onHighSchoolListClick}
        />
      ))}
    </div>
  );
};

export default Criteria;
